var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import * as PropTypes from 'prop-types';
/**
 * The valid values for the `type` Prop
 */
export var inputTypes = ['textarea', 'text', 'password'];
export var propTypes = {
    type: PropTypes.oneOf(__spreadArrays(inputTypes, [undefined])),
    value: PropTypes.string.isRequired,
    isPristine: PropTypes.bool.isRequired,
    validationErrors: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string.isRequired), PropTypes.string]),
    onChange: PropTypes.func,
    onKeyPress: PropTypes.func,
    validatable: PropTypes.bool
};
//# sourceMappingURL=types.js.map